/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Fragment, h } from "preact";
import styled from "styled-components";
import { Image } from "antd-mobile";
import Icon1 from "@images/icon/nav_0_0.png";
import Icon2 from "@images/icon/nav_0_1.png";
import Icon3 from "@images/icon/nav_1_0.png";
import Icon4 from "@images/icon/nav_1_1.png";
import Icon5 from "@images/icon/nav_2_0.png";
import Icon6 from "@images/icon/nav_2_1.png";
import Icon7 from "@images/icon/nav_3_0.png";
import Icon8 from "@images/icon/nav_3_1.png";
import Icon9 from "@images/icon/gg0.svg";
import Icon10 from "@images/icon/gg1.svg";

import { useEffect, useState } from "preact/hooks";
import "./navigation.css"
import { observer } from "mobx-react";
import { route } from "preact-router";
import { getAcId } from "../store/UserStore";
const Navigation: any = ({ store }: any) => {
    const [showFlag, setShowFlag] = useState(false);
    useEffect(() => {
        const list = [1, 2, 3, 4];
        if (list.indexOf(store.currentPage) != -1 && store.memberWhiteFlag) {
            if (store.currentPage == 1||store.currentPage==2) {
                if (store.mode == "default") {
                    setShowFlag(true);
                } else {
                    setShowFlag(false);
                }
            }else {
                setShowFlag(true);
            }
        } else {
            setShowFlag(false);
        }

    }, [store.memberWhiteFlag, store.currentPage, store.mode,store.searchVisitInputFocusFlag]);
    //登陆模块
    const initLogin=async (type: any)=>{
        const search = new URLSearchParams(window.location.search);
        if(type==1){
            window.scrollTo(0,0);
            store.currentPage=1;
            route(`/?${search.toString()}`);
        }else if(type==2){
            window.scrollTo(0,0);
            store.currentPage=2;
            route(`/visitthecommunity?${search.toString()}`);
        }else if(type==3){
            const acId=await getAcId();
            if(acId){
                window.scrollTo(0,0);
                store.currentPage=3;
                route(`/memberzone?${search.toString()}`);
            }else{
                store.currentPage=100;
                route(`/loginpage?${search.toString()}&previouspages=memberzone`);
            }
        }else if(type==4){
            const acId=await getAcId();
            if(acId){
                window.scrollTo(0,0);
                store.currentPage=4;
                route(`/personal?${search.toString()}`);
            }else{
                store.currentPage=100;
                route(`/loginpage?${search.toString()}&previouspages=personal`);
            }
        }
    }
    return (<Container className={showFlag ? "bottom_block" : ""}>
        <NavOut>
            <NavItem onClick={()=>{
                initLogin(1)
            }}>
                <NavIcon src={store.currentPage == 1 ? Icon2 : Icon1} />
                <NavText className={store.currentPage == 1 ? "nav_active" : ""}>首页</NavText>
            </NavItem>
            <NavItem onClick={()=>{
                initLogin(2)
            }}>
                <NavIcon src={store.currentPage == 2 ? Icon10 : Icon9} />
                <NavText className={store.currentPage == 2 ? "nav_active" : ""}>逛逛</NavText>
            </NavItem>
            <NavItem onClick={()=>{
                initLogin(3)
            }}>
                <NavIcon src={store.currentPage == 3 ? Icon6 : Icon5} />
                <NavText className={store.currentPage == 3 ? "nav_active" : ""}>0元兑换</NavText>
            </NavItem>
            <NavItem onClick={()=>{
                initLogin(4)
            }}>
                <NavIcon src={store.currentPage == 4 ? Icon8 : Icon7} />
                <NavText className={store.currentPage == 4 ? "nav_active" : ""}>我的</NavText>
            </NavItem>
        </NavOut>
        {store.bigPhone&&<NavBottom />}
    </Container>)
}

export default observer(Navigation);
const Container = styled.div`
   position: fixed;
   bottom: 0;
   display: none;
   width:750px;
 `;
const NavOut = styled.div`
    width: 100%;
    height: 122px;
    background: #FFFFFF;
    display:flex;
    flex-direction: row;
    align-items: center;
    padding:0 70px;
    justify-content: space-between;
 `;
const NavItem = styled.div`
    padding-top:29px;
    padding-bottom:11px;
    height: 122px;
    display: flex;
    flex-direction: column;
    align-items: center;
 `;
const NavIcon = styled.img`
    width: 44px;
 `;
const NavText = styled.div`
    margin-top:auto;
    font-weight: 500;
    color: #999999;
    font-size: 22px;
    line-height:30px;
 `;
 const NavBottom=styled.div`
    width: 100%;
    height: 32px;
    background-color:#fff;
 `